import { Injectable } from '@angular/core';
import { ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Observable } from 'rxjs';
import { loadStoreState, setInitialStoreState } from '../../../../common/utils';
import { TransportManagementFacade } from './transport-management.facade';
import { CatalogSearchCriteriaFacade, CatalogSearchCriteriaType } from '../../catalog-search-criteria';
import { CatalogSearchCriteria } from '../../../../common';
import { take } from 'rxjs/operators';
import {
  TransportManagementDefaultProfileFacade,
  TransportManagementProfileItemFacade,
} from '../transport-management-profile';

@Injectable({
  providedIn: 'root',
})
export class TransportManagementGuard {
  constructor(
    private transportManagementFacade: TransportManagementFacade,
    private transportManagementProfileItemFacade: TransportManagementProfileItemFacade,
    private transportManagementDefaultProfileFacade: TransportManagementDefaultProfileFacade,
    private catalogSearchCriteriaFacade: CatalogSearchCriteriaFacade,
  ) {}
  canActivate(_route: ActivatedRouteSnapshot, _state: RouterStateSnapshot): Observable<boolean> {
    return loadStoreState(this.transportManagementDefaultProfileFacade);
  }

  canDeactivate(): boolean {
    this.catalogSearchCriteriaFacade
      .getSearchCriteriaByCatalogType(CatalogSearchCriteriaType.TransportManagement)
      .pipe(take(1))
      .subscribe((searchCriteria: CatalogSearchCriteria) => {
        this.catalogSearchCriteriaFacade.changeSearchCriteriaByCatalogType(
          {
            ...searchCriteria,
            page: 0,
          },
          CatalogSearchCriteriaType.TransportManagement,
        );
      });
    setInitialStoreState(this.transportManagementDefaultProfileFacade);
    return setInitialStoreState(this.transportManagementFacade);
  }
}
